import Head from 'next/head';
import { useTranslation } from 'react-i18next';
import { useHasPercyChatAccess } from '@/components/agent-chat/hooks/use-chat-widget-enabled';
import NotEnabledShell from '@/components/not-enabled-shell';
import AskPercy from '@/features/ask-percy';

const SUPPORT_MAILTO = 'mailto:support@onefootprint.com?subject=Enable%20Percy';

const noop = () => {};

// Ask Percy is the global ChatWidget rendered fullscreen; this page is a thin shell that lets
// the widget (in PrivateLayout) overlay it. The widget derives fullscreen + open from the route
// (lockedFullscreen / effectiveOpen), so this page doesn't force any persisted widget state.
const AskPercyContent = () => {
  const { t } = useTranslation('ask-percy');

  return (
    <>
      <Head>
        <title>{t($ => $.pageTitle)}</title>
      </Head>
      <div className="absolute inset-0 bg-secondary" />
    </>
  );
};

const AskPercyNotEnabled = () => {
  const { t } = useTranslation('ask-percy');

  return (
    <>
      <Head>
        <title>{t($ => $.pageTitle)}</title>
      </Head>
      <NotEnabledShell
        message={t($ => $.notEnabled.banner)}
        cta={{ label: t($ => $.notEnabled.cta), href: SUPPORT_MAILTO }}
      >
        <AskPercy
          variant="full"
          isLoading={false}
          canStartChat={false}
          onSubmit={noop}
          labels={{
            title: t($ => $.title),
            subtitle: t($ => $.subtitle),
            inputPlaceholder: t($ => $.inputPlaceholder),
            loadingText: t($ => $.loadingText),
            dropOverlay: t($ => $.dropOverlay),
          }}
        />
      </NotEnabledShell>
    </>
  );
};

const AskPercyPage = () => {
  const hasPercyChatAccess = useHasPercyChatAccess();

  if (!hasPercyChatAccess) {
    return <AskPercyNotEnabled />;
  }

  return <AskPercyContent />;
};

export default AskPercyPage;
